//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectComponent from "../form/SelectComponent.vue";
import Genres from "~/components/gallery/Genres";
import MtSwitch from '~/components/form/MtSwitch'

export default {
  components: {
    SelectComponent,
    Genres,
    MtSwitch },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searching: false,
      types: {
        category: {
          label: this.$t('galleryParameters.typeLabel'),
          sorted: [],
          selected: [],
          filterSearchList: [],
          isSingle: false
        },
        period: {
          label: this.$t('galleryParameters.periodLabel'),
          sorted: [],
          selected: [],
          filterSearchList: [],
          isSingle: false
        },
        author: {
          label: this.$t('galleryParameters.authorLabel'),
          sorted: [],
          selected: [],
          filterSearchList: [],
          isSingle: false
        },
      },
      selectedGenres: [],
    }
  },
  computed: {
    canPatron () {
      if (typeof this.$route.query.canPatron === 'string') {
        return this.$route.query.canPatron === 'true'
      }

      return this.$route.query.canPatron
    }
  },
  mounted() {
    console.log(7777)
    this.sortAuthors(this.filters.author);
    this.sortType(this.filters.categories, 'category');
    this.sortType(this.filters.period, 'period');
    // this.sortType([
    //   {id: 1, name: this.$t('galleryParameters.mirLabel')},
    //   {id: 0, name: this.$t('galleryParameters.usersCollections')}
    // ], 'loyalty');
  },
  methods: {
    navigate (q) {
      const query = {...this.$route.query}
      this.$router.push({
        query: {
          ...query,
          ...q
        }
      })
    },
    sortAuthors(authors) {
      if (!authors) {
        return
      }
      const haveSelected = this.$route.query.hasOwnProperty('author')
      const selectedId = this.$route.query.author

      const result = authors.map((item, i) => {
        const fam = item.propertyFamValue.replace(/[()]/, '')
        let prevFam
        if (i) {
          prevFam = authors[i - 1].propertyFamValue.replace(/[()]/, '')
        }
        if (!prevFam || (i && fam && prevFam && fam[0].toUpperCase() !== prevFam[0].toUpperCase())) {
          item.letter = fam[0].toUpperCase()
        }
        if (haveSelected && selectedId && selectedId.includes(String(item.id))) {
          this.types.author.selected.push({...item, selected: true})
        }
        const name = item.name[0].toUpperCase() + item.name.slice(1)
        return {...item, name, selected: false}
      })

      let filteredResult
      if (selectedId) {
        filteredResult = result.filter(item => !selectedId.includes(String(item.id)))
      }

      this.types.author.sorted = this.types.author.selected && this.types.author.selected.length && filteredResult
        ? [{id: 'all', name: this.$t('galleryParameters.allLabel')}, ...this.types.author.selected, ...filteredResult]
        : [{id: 'all', name: this.$t('galleryParameters.allLabel')}, ...result]
    },
    sortType(data, type) {
      if (!data) {
        return
      }

      const result = [];
      const haveSelected = this.$route.query.hasOwnProperty([`${type}`])
      const selectedId = this.$route.query[`${type}`]

      data.forEach(item => {
        if (typeof item === 'string') {
          result.push({name: item, id: item, selected: false})
          if (haveSelected && selectedId && selectedId.includes(item)) {
            this.types[type].selected.push({name: item, id: item, selected: true})
          }
        } else {
          result.push({...item, name: item.name, selected: false})
          if (haveSelected && selectedId && selectedId.includes(String(item.id))) {
            this.types[type].selected.push({...item, name: item.name, selected: true})
          }
        }
      })

      let filteredResult
      if (selectedId) {
        filteredResult = result.filter(item => !selectedId.includes(String(item.id)))
      }
      this.types[type].sorted = this.types[type].selected && this.types[type].selected.length && filteredResult
        ? [{id: 'all', name: this.$t('galleryParameters.allLabel')}, ...this.types[type].selected, ...filteredResult]
        : [{id: 'all', name: this.$t('galleryParameters.allLabel')}, ...result]
    },

    searchFilteredValue(value, filterType) {
      this.types[filterType].filterSearchList = this.types[filterType].sorted.filter(item => item.name.toLowerCase().includes(value.toString().toLowerCase()))
    },

    goToFilter (selectedList, filterType, isSingle) {
      this.types[filterType].selected = []
      this.types[filterType].selected = [...selectedList]

      const query = {...this.$route.query}

      if (!isSingle && typeof query[`${filterType}`] === 'string') {
        query[`${filterType}`] = [query[`${filterType}`]]
      }

      if (!this.types[filterType].selected.length) {
        delete query[`${filterType}`]

        this.$nextTick(() => {
          this.$router.push({
            path: this.$route.path,
            query
          })
        })
      } else {
        delete query[`${filterType}`]
        const queryFilters = query[`${filterType}`] ? [...query[`${filterType}`]] : []

        this.types[filterType].selected.forEach(item => {
          queryFilters.push(item.id)
        })

        this.$router.push({
          path: this.$route.path,
          query: {
            ...query,
            [`${filterType}`]: queryFilters
          }
        })
      }

    }
  }
};
